import React, { useEffect } from "react";
import Select from "react-tailwindcss-select";
import { useAppConfig } from "../../Path/AppDashboard";
import { filter } from "lodash-es";
import { useTranslation } from "react-i18next";
const languages = [{ label: "English", value: "en" }, { label: "German", value: "de" }]

const LanguageSelector = () => {
    const { appConfig, setAppConfig } = useAppConfig();
    const {t} = useTranslation();
    useEffect(() => {
        if (appConfig.languages.length > 0) {
            const selectedLang = filter(languages, (lang) => appConfig.languages?.includes(lang.value))
            setAppConfig((prev) => ({ ...prev, selectedLanguage: selectedLang }))
        }else{
            setAppConfig((prev) => ({ ...prev, selectedLanguage: null }))
        }
    }, [appConfig.languages])
    
    return (
        <div className="mt-6 h-40">
            <h2 className="text-2xl font-bold mb-4 text-white">{t("SelectLanguage")}</h2>
            <form className="max-w-sm">
                <label className="block mb-2 text-sm font-medium text-white">{t("Choosealanguage")}</label>
                <Select
                    isMultiple
                    placeholder={t("select_language")}
                    options={languages}
                    value={appConfig.selectedLanguage}
                    primaryColor="indigo"
                    onChange={(e) => (setAppConfig((prev) => ({ ...prev, selectedLanguage: e })))}
                />
            </form>
        </div>
    );
}

export default LanguageSelector;
